import { useEffect, useState } from "react";
import i18n from "i18next";
import { CustomCookieIdentifier } from "@constants/shortbreadConfig";
import { DEFAULT_LANGUAGE } from "@utils/localizationUtils";
import { getEnabledLanguages } from "@utils/customBrandingUtils";
import { getDefaultCrossPortalCookieOptions } from "@utils/cookieUtils";
import { Language } from "@constants/i18n";
import { useGetCookieManager } from "@hooks/useGetCookieManager";

const useI18nLanguage = () => {
    const cookieManagerInstance = useGetCookieManager();

    const [language, setLanguage] = useState<string>();
    const enabledLanguages = getEnabledLanguages();

    useEffect(() => {
        const handleLanguageChange = (lng) => {
            setLanguage(lng);
            cookieManagerInstance.setCookieStorage(
                CustomCookieIdentifier.WSW_LANGUAGE.name,
                lng,
                getDefaultCrossPortalCookieOptions()
            );
        };

        i18n.on("languageChanged", handleLanguageChange);

        return () => {
            i18n.off("languageChanged", handleLanguageChange);
        };
    }, []);

    useEffect(
        () => {
            const selectedLanguageFromCookie =
                cookieManagerInstance.getCookieStorage(
                    CustomCookieIdentifier.WSW_LANGUAGE.name
                );
            const selectedLanguage: Language =
                language ?? selectedLanguageFromCookie ?? i18n.language;
            if (!enabledLanguages || enabledLanguages.size === 0) {
                void i18n.changeLanguage(selectedLanguage);
                return;
            }

            // Custom localized messages exist
            if (enabledLanguages.has(selectedLanguage)) {
                void i18n.changeLanguage(selectedLanguage);
                return;
            }
            if (enabledLanguages.has(Language.English)) {
                void i18n.changeLanguage(Language.English);
                return;
            }
            void i18n.changeLanguage(Array.from(enabledLanguages).sort()[0]);
        },
        Array.from(enabledLanguages ?? [])
    );

    return {
        language: language ?? DEFAULT_LANGUAGE,
        changeLanguage: (lng) => void i18n.changeLanguage(lng),
    };
};

export default useI18nLanguage;
